import React, { useId } from "react";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import ApiData from "../../../api/ApiData";
import { BtnPrimaryv4 } from "../../UI/button/BtnPrimaryv4";
import { BtnOutlineV4 } from "../../UI/button/BtnOutlineV4";

export const ModalWaringClientID = ({ clientID, setModalWaringFlag }) => {
  const titleId = useId();

  const deleteClient = () => {
    ApiData.deleteClientID(clientID);
    setModalWaringFlag(false);
  };

  const close = () => setModalWaringFlag(false);

  if (!clientID) {
    return null;
  }

  return (
    <SideDrawer
      open
      onClose={close}
      title="Отвязать client-id"
      titleId={titleId}
      usePortal={false}
      toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
      footer={
        <>
          <BtnPrimaryv4 text="Отвязать клиента" onClick={deleteClient} />
          <BtnOutlineV4 text="Отмена" onClick={close} />
        </>
      }
    >
      <div className="site-modal-body">
        <p className="admin-confirm-text">
          Вы уверены, что хотите отвязать софт{" "}
          <strong>{clientID.software_client_rel.name}</strong> с client-id{" "}
          <span className="company-card-v4-mono">{clientID.client_id}</span> от
          организации <strong>{clientID.company_rel.name_company}</strong>?
        </p>
      </div>
    </SideDrawer>
  );
};
